/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PeriodicEnum } from "./PeriodicEnum";
import {
  PeriodicEnumFromJSON,
  PeriodicEnumFromJSONTyped,
  PeriodicEnumToJSON,
  PeriodicEnumToJSONTyped,
} from "./PeriodicEnum";

/**
 *
 * @export
 * @interface UploadLateralFile
 */
export interface UploadLateralFile {
  /**
   *
   */
  readonly putUrl?: string;
  /**
   *
   */
  filename: string;
  /**
   *
   */
  readonly status?: string;
  /**
   *
   */
  offset: number;
  /**
   *
   */
  periodic?: PeriodicEnum;
}

/**
 * Check if a given object implements the UploadLateralFile interface.
 */
export function instanceOfUploadLateralFile(value: object): value is UploadLateralFile {
  if (!("filename" in value) || value["filename"] === undefined) return false;
  if (!("offset" in value) || value["offset"] === undefined) return false;
  return true;
}

export function UploadLateralFileFromJSON(json: any): UploadLateralFile {
  return UploadLateralFileFromJSONTyped(json, false);
}

export function UploadLateralFileFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UploadLateralFile {
  if (json == null) {
    return json;
  }
  return {
    putUrl: json["put_url"] == null ? undefined : json["put_url"],
    filename: json["filename"],
    status: json["status"] == null ? undefined : json["status"],
    offset: json["offset"],
    periodic: json["periodic"] == null ? undefined : PeriodicEnumFromJSON(json["periodic"]),
  };
}

export function UploadLateralFileToJSON(json: any): UploadLateralFile {
  return UploadLateralFileToJSONTyped(json, false);
}

export function UploadLateralFileToJSONTyped(
  value?: Omit<UploadLateralFile, "putUrl" | "status"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    filename: value["filename"],
    offset: value["offset"],
    periodic: PeriodicEnumToJSON(value["periodic"]),
  };
}
